<template>
  <div id="app" role="presentation">
    <transition name="fade">
      <div class="loader-fullpage" v-show="loading">
        <span class="logo-loader">
          <img src="./assets/map.png" alt="Loading..">
        </span>
      </div>
    </transition>
    <geo-location-modal />
    <div class="page-container" ref="pageContainer" role="presentation" tabindex="-1">
      <div class="wrapper" role="presentation">
        <HeaderDesktop />
        <router-view/>
      </div>
      <AppFooter />
    </div>
  </div>
</template>

<script>
import HeaderDesktop from '@/components/HeaderDesktop'
import AppFooter from '@/components/Footer'
import GeoLocationModal from '@/components/GeoLocationModal'
import { mapState, mapMutations, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    HeaderDesktop,
    AppFooter,
    GeoLocationModal
  },
  data () {
    return {
      collegeFont: ''
    }
  },
  async created () {
    this.watchPosition()

    let collegeFontId = this.$store.state.college.settings['college_font']
    if (collegeFontId) {
      const response = await axios.get(`/files/${collegeFontId}`)
      this.collegeFont = '@font-face {font-family: "CustomFont"; src: url(' + response.data.url + ') }'
    }
    this.setupStyles()

    await this.$gmapApiPromiseLazy()
  },
  mounted () {
    this.endLoad()
  },
  beforeDestroy () {
    this.unwatchPosition()
  },
  methods: {
    ...mapMutations(['startLoad', 'endLoad']),
    ...mapActions(['watchPosition', 'unwatchPosition']),

    setupStyles () {
      let mainColor = this.$store.state.college.settings['main_color']
      let secondaryColor = this.$store.state.college.settings['secondary_color']
      let collegeFavicon = this.$store.state.college.settings['college_favicon']
      let mobileBackground = this.$store.state.college.settings['background_img']
      let desktopBackground = this.$store.state.college.settings['background_img_desktop']
      let namecaptureTextColor
      let namecaptureBackgroundColor

      if (this.$store.state.college.settings.namecapture_form) {
        namecaptureTextColor = this.$store.state.college.settings.namecapture_form.text_color
        namecaptureBackgroundColor = this.$store.state.college.settings.namecapture_form.background_color
      } else {
        namecaptureTextColor = mainColor
        namecaptureBackgroundColor = secondaryColor
      }

      if (collegeFavicon) {
        const favicon = document.getElementById('favicon')
        favicon.href = collegeFavicon
      }

      let style1 = `.main-background {background-color: ${mainColor}}`

      let style2 = `.secondary-background {background-color: ${secondaryColor}}`

      let style3 = `.main-color {color: ${mainColor}}`

      let style4 = `.secondary-text {color: ${secondaryColor}}`

      let style5 = `.home:before {border-top-color: ${mainColor}border-left-color: ${mainColor}}`

      let style6 = `.sbnc-modal {background-color: ${namecaptureBackgroundColor}} .sbnc-form-button {color: ${secondaryColor}; background-color: ${mainColor}} .sbnc-privacy-link {color: ${namecaptureTextColor}} .sbnc-row-title {color: ${namecaptureTextColor}}`

      let style7 = `.tour .categories:after, .tour .list-buildings:after, .explore-campus .list-buildings:before {background-color: ${mainColor}} .tour .categories .category-block, .tour .list-buildings .category-block, .tour .categories .build-wrapper, .tour .list-buildings .build-wrapper, .location-notification {border-color: ${mainColor}}`

      let style8 = `.view-poi .tabs li.router-link-active {color: ${mainColor}} .view-poi .content-box .content {background-color: ${secondaryColor}} .view-poi .adp-directions tr > td.adp-substep:last-child:after {border-top-color: ${mainColor}}`

      let style9 = `.home-page .home-menu ul .home-btn:after {background-color: ${secondaryColor}} .home-page .ctas .cta {color: ${secondaryColor}}`

      let style10 = `.btn {border-color: ${mainColor}} .btn-border {border: 2px solid ${mainColor}}`

      let style11 = `.player-progress {background-color: ${mainColor}} .play-btn {border-color: ${mainColor}} .main-border {border-color: ${mainColor}} .before-colors:before {background-color: ${mainColor}}`

      let style12 = `.personalized-tour .poi-categories {border-color: ${mainColor}} .personalized-tour .poi-categories .category-block {border-color: ${mainColor}}`

      let style13 = `.footer .share .share-content li:hover, .footer .share .share-content li:focus, .footer .share .share-content li:active {background-color: ${mainColor}}`

      let style14 = `.header-container .header .ctas .cta:hover, .header-container .header .ctas .cta:focus, .header-container .header .ctas .cta:active {background-color: ${mainColor}; color: ${secondaryColor};}`

      let style15 = `@media screen and (min-width: 768px){ .tour .content > .description {background-color: ${mainColor};} .home-page .heading-wrapper h1 {background-color: ${mainColor}; color: #fff;} }`

      let style16 = `header .skip-btn { background-color: ${mainColor}; }`

      let style17 = `.page-container, .home-page { background-image: url(${mobileBackground}); } @media screen and (min-width: 768px){ .page-container, .home-page { background-image: url(${desktopBackground || mobileBackground}); } }`

      let styleNode = document.createElement('style')
      styleNode.textContent = `${this.collegeFont}${style1}${style2}${style3}${style4}${style5}${style6}${style7}${style8}${style9}${style10}${style11}${style12}${style13}${style14}${style15}${style16}${style17}`
      document.head.appendChild(styleNode)
    }
  },
  computed: mapState({
    loading: state => state.loadCounter > 0,
    ...mapState({
      stng: state => state.college.settings.non_mobile_popup
    })
  }),
  watch: {
    $route (to, from) {
      if (to.meta && to.meta.block !== 'Poi') {
        this.$refs.pageContainer.focus()
      }
    }
  }
}
</script>

<style lang="stylus" src="@/styles/main.styl"></style>
